// extracted by mini-css-extract-plugin
export default {"container":"sp-z","bubbleNav":"tp-z","graphic":"up-z","contact":"vp-z"};